<script lang="ts" setup name="OrganisationShipmentPortContactsCard">
import BaseCollapsible from '~/components/BaseCollapsible.vue';
import BaseDivideWrapper from '~/components/BaseDivideWrapper.vue';
import BaseItem from '~/components/BaseItem.vue';
import CustomCard from '~/components/CustomCard.vue';
import OrganisationShipmentPortContactsTrigger from '~/components/OrganisationShipmentPortContactsTrigger.vue';

const { title = '', items = [] } = defineProps<{
  title?: string;
  items?: {
    triggerItems: {
      title: string;
      subtitle: string;
      icon: string;
    }[];
    contentItems: {
      title: string;
      subtitle: string;
      email: string;
    }[];
  }[];
}>();
</script>

<template>
  <CustomCard>
    <div class="mb-4 shrink-0 px-6 pt-6">
      <p class="text-subtitle-1 text-charcoal-9">{{ title }}</p>
    </div>
    <BaseDivideWrapper with-top-border>
      <BaseCollapsible v-for="(item, index) in items" :key="index">
        <template #trigger="{ toggle, isOpen }">
          <OrganisationShipmentPortContactsTrigger
            :items="item.triggerItems"
            :open="isOpen"
            @click="toggle"
          />
        </template>
        <div
          class="flex flex-col space-y-4 rounded-b bg-charcoal-1 px-6 py-6 sm:grid sm:grid-cols-[250px_minmax(0,_1fr)] sm:gap-6 sm:space-y-0 sm:pl-14"
        >
          <BaseItem
            v-for="contentItem in item.contentItems"
            :key="contentItem.email"
            v-bind="contentItem"
          />
        </div>
      </BaseCollapsible>
    </BaseDivideWrapper>
  </CustomCard>
</template>
